import Dashboard from '@chegg-wt/core/components/Dashboard'

export default Dashboard
